export default [
    {
        key: 'FeeTypeIssuedModal',
        getComponent: function () { return import('./FeeTypeIssuedModal'); },
        title: i18n.get('费用类型'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'BatchSettingModal',
        getComponent: function () { return import('./BatchSettingModal'); },
        title: i18n.get('批量设置'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
